import React from 'react';
import { Globe, Award, Users, Heart } from 'lucide-react';

const AboutPage = () => {
  return (
    <div>
      <section className="bg-gradient-to-r from-amber-600 to-orange-600 text-white py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl font-bold mb-6">Over WK Informatie</h1>
            <p className="text-2xl mb-8 opacity-90">
              Jouw betrouwbaarste bron voor informatie over het Wereldkampioenschap Voetbal
            </p>
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-3xl font-bold mb-6 text-gray-800">Onze Missie</h2>
                <p className="text-lg text-gray-700 mb-4">
                  WK Informatie is opgericht met als doel om voetbalfans in Nederland en België compleet te informeren over het Wereldkampioenschap Voetbal.
                </p>
                <p className="text-lg text-gray-700 mb-4">
                  Wij bieden actuele informatie, analyse, en achtergronden over het WK, met speciale aandacht for Oranje en de Nederlandse supporters.
                </p>
                <p className="text-lg text-gray-700">
                  Ons team van voetbalexperts en journalisten werkt dagelijks aan het brengen van het laatste nieuws en de beste analyses.
                </p>
              </div>
              <div className="grid grid-cols-2 gap-6">
                <div className="text-center p-6 bg-amber-50 rounded-xl">
                  <Award className="w-12 h-12 text-amber-600 mx-auto mb-3" />
                  <div className="text-3xl font-bold text-amber-600 mb-2">10+</div>
                  <div className="text-gray-600">Jaar Ervaring</div>
                </div>
                <div className="text-center p-6 bg-amber-50 rounded-xl">
                  <Users className="w-12 h-12 text-amber-600 mx-auto mb-3" />
                  <div className="text-3xl font-bold text-amber-600 mb-2">1M+</div>
                  <div className="text-gray-600">Bezoekers per WK</div>
                </div>
                <div className="text-center p-6 bg-amber-50 rounded-xl">
                  <Globe className="w-12 h-12 text-amber-600 mx-auto mb-3" />
                  <div className="text-3xl font-bold text-amber-600 mb-2">500+</div>
                  <div className="text-gray-600">Artikelen</div>
                </div>
                <div className="text-center p-6 bg-amber-50 rounded-xl">
                  <Heart className="w-12 h-12 text-amber-600 mx-auto mb-3" />
                  <div className="text-3xl font-bold text-amber-600 mb-2">100%</div>
                  <div className="text-gray-600">Passie voor Voetbal</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;